import React from 'react';
import './speech-option.css';
import { Paragraph } from '../../../../components/paragraph';
import { IconButton } from '../../../../components/icon-button';

const SpeechOption = props => {
    const { option, onClick } = props;

    return (
        <div className="speech-option">
            <Paragraph withSpacing={false}>{option.text}</Paragraph>
            <IconButton
                onClick={onClick}
                iconName="plus"
                size="small"
                withSpacing={true}
                altText="add to speech"
            />
        </div>
    );
};

export { SpeechOption };
